var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categoty-icon"},[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({attrs:{"src":require(("@/assets/" + _vm.image)),"alt":""}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.category))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }